import React from 'react';
import ReactDOM from 'react-dom';
import AppContainer from './containers/AppContainer';
import store from './store';
import * as Sentry from '@sentry/browser';
import WebGLContext from './components/WebGLContext';
import { getSentryEnv, logSentryException } from './services/util';
import { getLocalhostRedirectUrl } from './services/localhostRedirect';
import './i18n/i18n';
require('./app.scss');

// Load debugging utilities (includes window.testContextLoss() for testing context restoration)
if (process.env.NODE_ENV !== 'production') {
  require('./texture-debug-utils');
}

window.onerror = function(e){
  if(e.includes("ResizeObserver loop limit exceeded")){
   return true;
  }

  if(e.includes("unityAbort")){
    console.log("Reloading due to Unity Abort");
    logSentryException(new Error('Unity abort detected'), 'Reloading due to Unity Abort', { originalError: typeof e === 'string' ? e : e?.message });
    location.reload();
  }
}

// Show the git commmit hash
console.log(BRANCH,VERSION,COMMITHASH);

// Dynamically log accessibility issues to console for analysis
const urlParams = new URLSearchParams(window.location.search);
if (process.env.NODE_ENV !== 'production' && urlParams.get("logA11y")) {
  const axe = require('@axe-core/react');
  const axeConfig = {
    disableDeduplicate: true,
  };

  axe(React, ReactDOM, 1000, axeConfig);
}

// DebugMenu "Redirect launches to localhost" (DEV/STAGE only): replay token-bearing
// launch URLs against the local dev server. Checked before render so the token is
// never consumed here — no duplicate session, no query-string-strip race.
const localhostRedirectUrl = getLocalhostRedirectUrl();

// Render app
if (localhostRedirectUrl) {
  window.location.replace(localhostRedirectUrl);
} else {
  ReactDOM.render(
    <WebGLContext>
      {(webglProps) => <AppContainer webglProps={webglProps} store={store} />}
    </WebGLContext>
    , document.getElementById('root'));
}

// Initialize Sentry
 Sentry.init({
    dsn: "https://1536de4e059c4a0ab494149a234d9ac8@sentry.io/1427299",
    beforeSend: filterEvents,
    release: process.env.COMMITHASH,
    environment: getSentryEnv(),
  },
  );

  //TODO: move to another file.

  let alreadyAllowedEvent = false;
  function filterEvents(event,hint){
    if(event && event.exception && event.exception.values){
      let exception = event.exception.values[0];
      if(exception.type == "TypeError" && exception.value == "Unable to get property 'x' of undefined or null reference"
        && exception.stacktrace && exception.stacktrace.frames && exception.stacktrace.frames[exception.stacktrace.frames.length-1]
        && (exception.stacktrace.frames[exception.stacktrace.frames.length-1].function == "handlerFunc")){
          if(alreadyAllowedEvent){
            console.log("Eating error",event);
            return null;
          }else{
            alreadyAllowedEvent = true;
          }
      }
    }
    return event;
  }
